import Badge from './Badge.jsx';

export {
  Badge
};



/** WEBPACK FOOTER **
 ** ./client/shared/packages/Badge/src/index.js
 **/